/* MenoGlow – Interaktionen (Port der React-Logik) */
(function () {
  /* Fallback-Konfiguration. Kann pro Formular per data-endpoint / data-or ueberschrieben werden. */
  var AC_ENDPOINT = 'https://menoglow.activehosted.com/proc.php';
  var OR_HASHES = {
    '1': '340347c2-c82f-4659-ac90-d1425b7a3d9e',
    '3': 'b3b7a4ec-a2f5-4222-96d1-f78b86932749',
    '5': '2529d62b-ede3-4d9a-9ba1-1601ad361861',
    '8': '245be758-e64f-4159-806d-9ef5f6a8aec7',
    '10': 'bb4f46ce-7924-4e88-acb3-a52fadf5a3a4',
    '13': '835b87c7-31b2-4893-9577-d5598992df6b',
    '18': '8bb2bd00-124c-483c-9e81-434dc2d7a445',
    '23': 'a34b766d-3c98-467a-9801-688185d90c22',
    '27': '16af7487-5de2-48a4-b1cc-bc86bb7c4885',
    '29': '95555330-52d0-4263-a247-5ce217446c21'
  };

  function icons() { if (window.lucide) window.lucide.createIcons(); }

  /* ---------- Scroll Reveal (scroll-basiert, robust) ---------- */
  function reveal() {
    var check = function () {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var els = document.querySelectorAll('.mg-reveal:not(.is-visible)');
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < vh - 40 && r.bottom > 0) {
          var d = el.getAttribute('data-delay');
          if (d && parseFloat(d) > 0) el.style.animationDelay = d + 's';
          el.classList.add('is-visible');
        }
      });
      return els.length;
    };
    check();
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check, { passive: true });
    var n = 0;
    var iv = setInterval(function () { check(); if (++n > 20) clearInterval(iv); }, 250);
  }

  /* ---------- Modals ---------- */
  function openModal(id) {
    var m = document.getElementById('mg-modal-' + id);
    if (!m) return;
    m.classList.remove('hidden');
    m.classList.add('flex');
    document.body.style.overflow = 'hidden';
    icons();
  }
  function closeModal(m) {
    if (!m) return;
    m.classList.add('hidden');
    m.classList.remove('flex');
    document.body.style.overflow = '';
  }
  function initModals() {
    document.addEventListener('click', function (ev) {
      var opener = ev.target.closest('[data-mg-open]');
      if (opener) { ev.preventDefault(); openModal(opener.getAttribute('data-mg-open')); return; }
      var closer = ev.target.closest('[data-mg-close]');
      if (closer) { ev.preventDefault(); closeModal(closer.closest('.mg-modal')); return; }
      if (ev.target.classList && ev.target.classList.contains('mg-modal')) closeModal(ev.target);
    });
    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape') document.querySelectorAll('.mg-modal:not(.hidden)').forEach(closeModal);
    });
  }

  /* ---------- ActiveCampaign Formulare ---------- */
  function initForms() {
    document.querySelectorAll('form.mg-ac-form, form.mg-form').forEach(function (form) {
      if (form.getAttribute('data-mg-ready')) return;
      form.setAttribute('data-mg-ready', '1');
      var errEl = form.querySelector('.mg-ac-error');
      var showErr = function (msg) {
        if (!errEl) { if (msg) window.alert(msg); return; }
        errEl.textContent = msg || '';
        if (msg) { errEl.classList.remove('hidden'); } else { errEl.classList.add('hidden'); }
      };
      var attr = function (el, n, fb) { var v = el.getAttribute(n); return (v === null || v === '') ? fb : v; };

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        showErr('');
        var formId = attr(form, 'data-form-id', '');
        var nameKey = attr(form, 'data-name-key', 'firstname');
        var inputs = form.querySelectorAll('[data-mg-field]');
        if (!inputs.length) { inputs = form.querySelectorAll('[name="mg_email"], [name="mg_name"]'); }
        var p = { _q: [], append: function (k, v) { this._q.push(k + '=' + encodeURIComponent(v == null ? '' : v)); }, toString: function () { return this._q.join('&'); } };
        p.append('u', formId); p.append('f', formId); p.append('s', '');
        p.append('c', '0'); p.append('m', '0'); p.append('act', 'sub'); p.append('v', '2');
        p.append('or', attr(form, 'data-or', OR_HASHES[formId] || ''));

        var bad = null, badMsg = '';
        for (var i = 0; i < inputs.length; i++) {
          var el = inputs[i];
          var key = attr(el, 'data-mg-field', el.name === 'mg_email' ? 'email' : nameKey);
          var val = (el.value || '').trim();
          var isMail = el.type === 'email' || key === 'email';
          if (!val && (el.required || isMail)) { bad = el; badMsg = attr(el, 'data-mg-error', ''); break; }
          if (val && isMail && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(val)) { bad = el; badMsg = attr(el, 'data-mg-error', ''); break; }
          p.append(key, val);
        }
        if (bad) {
          showErr(badMsg || attr(form, 'data-error', 'Bitte pruefe Deine Eingaben.'));
          try { bad.focus(); } catch (err) {}
          return;
        }

        var req = form.querySelectorAll('[data-mg-check][required]');
        for (var r = 0; r < req.length; r++) {
          if (!req[r].checked) {
            showErr(attr(req[r], 'data-mg-error', 'Bitte setze das Häkchen, um fortzufahren.'));
            try { req[r].focus(); } catch (err) {}
            return;
          }
        }

        var boxes = form.querySelectorAll('[data-mg-check]');
        if (boxes.length) {
          boxes.forEach(function (nl) {
            p.append(nl.getAttribute('data-mg-check'), nl.checked ? attr(nl, 'data-label', '1') : '~|');
          });
        } else {
          var legacy = form.querySelector('[name="mg_newsletter"]');
          if (legacy) { p.append('field[3][]', legacy.checked ? attr(legacy, 'data-label', '1') : '~|'); }
        }

        var btn = form.querySelector('button[type="submit"]');
        var label = btn ? btn.innerHTML : '';
        if (btn) { btn.disabled = true; btn.textContent = attr(form, 'data-sending', 'Wird gesendet...'); }

        var base = attr(form, 'data-endpoint', AC_ENDPOINT);
        var s = document.createElement('script');
        s.src = base + (base.indexOf('?') < 0 ? '?' : '&') + p.toString() + '&jsonp=true';
        var done = function () {
          form.classList.add('hidden');
          var scope = form.parentElement || document;
          var ok = scope.querySelector('.mg-ac-success');
          if (ok) { ok.classList.remove('hidden'); icons(); }
        };
        window._show_error = function (id, msg) {
          s._mgErr = true;
          if (btn) { btn.disabled = false; btn.innerHTML = label; }
          showErr(msg || attr(form, 'data-error-send', 'Es gab ein Problem. Bitte versuche es erneut.'));
        };
        s.onload = function () { if (!s._mgErr) done(); };
        s.onerror = function () {
          if (btn) { btn.disabled = false; btn.innerHTML = label; }
          showErr(attr(form, 'data-error-send', 'Es gab ein Problem. Bitte versuche es erneut.'));
        };
        document.body.appendChild(s);
        setTimeout(function () { if (s.parentNode) document.body.removeChild(s); }, 5000);
      });
    });
  }
/* ---------- Header ---------- */
  function initHeader() {
    var timers = {};
    document.querySelectorAll('[data-mg-dropdown]').forEach(function (wrap) {
      var id = wrap.getAttribute('data-mg-dropdown');
      var panel = wrap.querySelector('[data-mg-dropdown-panel]');
      var chev = wrap.querySelector('[data-mg-chevron]');
      if (!panel) return;
      var show = function () {
        clearTimeout(timers[id]);
        panel.classList.remove('hidden');
        if (chev) chev.classList.add('rotate-180');
      };
      var hide = function () {
        timers[id] = setTimeout(function () {
          panel.classList.add('hidden');
          if (chev) chev.classList.remove('rotate-180');
        }, 150);
      };
      wrap.addEventListener('mouseenter', show);
      wrap.addEventListener('mouseleave', hide);
      var btn = wrap.querySelector('button');
      if (btn) btn.addEventListener('click', function (e) { e.preventDefault(); panel.classList.toggle('hidden'); });
    });

    var sheet = document.getElementById('mg-mobile-sheet');
    var openBtn = document.getElementById('mg-mobile-open');
    if (sheet && openBtn) {
      var panel = sheet.querySelector('[data-sheet-panel]');
      var open = function () {
        sheet.classList.remove('pointer-events-none');
        sheet.classList.remove('opacity-0');
        panel.classList.remove('translate-x-full');
        document.body.style.overflow = 'hidden';
      };
      var close = function () {
        sheet.classList.add('opacity-0');
        panel.classList.add('translate-x-full');
        document.body.style.overflow = '';
        setTimeout(function () { sheet.classList.add('pointer-events-none'); }, 300);
      };
      openBtn.addEventListener('click', open);
      sheet.addEventListener('click', function (e) {
        if (e.target === sheet || e.target.closest('[data-sheet-close]')) close();
      });
    }

    document.querySelectorAll('[data-mg-accordion]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var t = document.getElementById(btn.getAttribute('data-mg-accordion'));
        var c = btn.querySelector('[data-mg-chevron]');
        if (t) t.classList.toggle('hidden');
        if (c) c.classList.toggle('rotate-180');
      });
    });

    document.querySelectorAll('[data-mg-popover]').forEach(function (wrap) {
      var btn = wrap.querySelector('[data-mg-popover-trigger]');
      var panel = wrap.querySelector('[data-mg-popover-panel]');
      if (!btn || !panel) return;
      btn.addEventListener('click', function (e) { e.stopPropagation(); panel.classList.toggle('hidden'); });
      document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) panel.classList.add('hidden'); });
    });
  }

  /* ---------- Smooth Scroll zu Sektionen ---------- */
  function initAnchors() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-mg-scroll]');
      if (!a) return;
      var id = a.getAttribute('data-mg-scroll');
      var el = document.getElementById(id);
      if (el) { e.preventDefault(); el.scrollIntoView({ behavior: 'smooth' }); }
    });
  }

  /* ---------- Scroll to top ---------- */
  function initScrollTop() {
    var b = document.getElementById('mg-scroll-top');
    if (!b) return;
    var toggle = function () {
      if (window.scrollY > 400) { b.classList.remove('opacity-0', 'pointer-events-none'); }
      else { b.classList.add('opacity-0', 'pointer-events-none'); }
    };
    window.addEventListener('scroll', toggle, { passive: true });
    b.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
    toggle();
  }

  function boot() {
    icons(); reveal(); initModals(); initForms(); initHeader(); initAnchors(); initScrollTop();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.addEventListener('load', icons);
  window.mgOpenModal = openModal;
})();
